export const getUSDValueTo1ETH = async () =>{
    const response = await fetch('https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD');
    return response.json();
}